// ProfessorDashboard.js (main file)
import React, { useState, useEffect } from "react";
import "../css/Professor_dashboard.css";
import { useNavigate } from "react-router-dom";
import AddProject from "./AddProject";
import ViewProjects from "./ViewProjects";
import AllottedStudents from "./ AllottedStudents.js";
import ProjectReports from "./ProjectReports";

function ProfessorDashboard() {
  const [activeTab, setActiveTab] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();

  // Check authentication on mount
  useEffect(() => {
    const token = localStorage.getItem("access_token");
    setIsAuthenticated(!!token);
  }, []);

  // Logout handler
  const handleLogout = () => {
    localStorage.removeItem("access_token");
    setIsAuthenticated(false);
    navigate("/login");
  };

  if (!isAuthenticated) {
    return (
      <div className="dashboard-container">
        <h2>You must be logged in as a professor to access this page.</h2>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-sidebar">
        <button className="sidebar-btn" onClick={() => setActiveTab("add")}>
          Add Project
        </button>
        <button className="sidebar-btn" onClick={() => setActiveTab("view")}>
          View Projects
        </button>
        <button className="sidebar-btn" onClick={() => setActiveTab("students")}>
          Allotted Students
        </button>
        {/* <button className="sidebar-btn" onClick={() => setActiveTab("project_reports")}>
          Project Reports
        </button> */}
        <button className="sidebar-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>

      <div className="dashboard-main">
        {activeTab === "add" && <AddProject />}
        {activeTab === "view" && <ViewProjects />}
        {activeTab === "students" && <AllottedStudents />}
        {activeTab === "project_reports" && <ProjectReports />}

        {!activeTab && (
          <div>
            <h2>Welcome to Professor </h2>
            <p>Dear Professor, Please create a project by 5PM 30th April 2026</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default ProfessorDashboard;